/**
 * Only for `search-web` search result catalog page (newSearchResult.html)
 **/

'use strict';

/* Synced with search.common.js, unable to call function outside js file */
function initializeReadMoreParagraph () {
  $('.js-readMoreParagraph').each(function ( index ) {
    var lineHeight = $(this).data('readmore-line-height') || 21;
    var numLines = $(this).data('readmore-line-count') || 3;
    var margin = $(this).data('readmore-line-margin') || 0;
    var expandLabel = $(this).data('readmore-expand-label') || '続きを見る';
    var expandLabelEn = $(this).data('readmore-expand-label-en') || 'Expand';
    var collapseLabel = $(this).data('readmore-collapse-label') || '閉じる';
    var collapseLabelEn = $(this).data('readmore-collapse-label-en') || 'Collapse';

    var selectedReadMore = $(this);

    var language = $('html').attr('lang');
    var moreLabel = expandLabel
    var lessLabel = collapseLabel

    if (language === 'en') {
      moreLabel = expandLabelEn
      lessLabel = collapseLabelEn
    }

    $(selectedReadMore).readmore({
      speed: 200,
      collapsedHeight: (lineHeight * numLines) + margin,
      heightMargin: lineHeight * 0,
      moreLink: '<a class="accBtn">' + moreLabel + '</a>',
      lessLink: '<a class="accBtn">' + lessLabel + '</a>',
      embedCSS: false
    });

    $('#tab-ctl-01, #tab-ctl-02, #tab-ctl-03').on('change',function(e){
      var marker = $(e.currentTarget).attr('id').slice(-2);
      var $targetPanel = $(e.currentTarget)
                        .siblings('.body')
                        .children('#tab-panel-' + marker);
      var $target = $targetPanel.children(selectedReadMore);

      $target.readmore({
        speed: 200,
        collapsedHeight: lineHeight * numLines,
        heightMargin: lineHeight * 0,
        moreLink: '<a>' + moreLabel + '</a>',
        lessLink: '<a>' + lessLabel + '</a>',
        embedCSS: false
      });
    });

    $(window).on('resize', function(e){
      $(selectedReadMore).readmore({
        speed: 200,
        collapsedHeight: lineHeight * numLines,
        heightMargin: lineHeight * 0,
        moreLink: '<a>' + moreLabel + '</a>',
        lessLink: '<a>' + lessLabel + '</a>',
        embedCSS: false
      });
    });
  });
}


$(function(){

  //slider
  if($('.js_slider').length){
      $('.js_slider ul').each(function(){
          var $slickElement = $(this);
          var $status = $slickElement.siblings('.slidePaging').find('span');
          $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
              var i = (currentSlide ? currentSlide : 0) + 1;
              $status.text(i + '/' + slick.slideCount);
          });
          $slickElement.slick({
              'prevArrow':'<button type=button class=slick-prev>&#xf104;</button>',
              'nextArrow':'<button type=button class=slick-next>&#xf105;</button>',
              'infinite':false
          });
          
      });

      $('.c-modal, #catalogPreviewModal').on('shown.bs.modal', function (event) {
          var clickBotton = $(event.relatedTarget).data('clickbotton');
          $(this).find('.js_slider ul').slick('setPosition');
      });
  }

  // PAT : this only applicable for `search-web`
  $(window).on("load",function(){
    $(".catalogPreview").each(function(){
        $(this).data("target","#catalogPreviewModal");
    });
  });

  $("#catalogPreviewModal").on("hidden.bs.modal", function(ev){
      // $("#previewCatalogImage1").removeAttr("src");
      try {
        $('.slick-slider').slick('slickRemove', null, null, true);
      }catch(e){
        return;
      }
  });
  $("#catalogPreviewModal").on("show.bs.modal", function(ev){
      var previewFocus = $(ev.relatedTarget).closest('li');
      
      try {
        $('.slick-slider').slick('slickRemove', 0);
      }catch(e){
        return;
      }

      // $("#previewCatalogImage1").attr({"src":previewFocus.find('[name="catalogImage1"]').val()});
      var catalogImage1path = previewFocus.find('[name="catalogImage1"]').val();
      if (catalogImage1path != undefined) {
          $(this).find('.js_slider ul').slick('slickAdd', '<li><figure class="img"><span><img class="m_imgShadow" src="' + previewFocus.find('[name="catalogImage1"]').val() + '"></span></figure></li>');
      }
      var catalogImage2path = previewFocus.find('[name="catalogImage2"]').val();
      if (catalogImage2path != undefined) {
          $(this).find('.js_slider ul').slick('slickAdd', '<li><figure class="img"><span><img class="m_imgShadow" src="' + previewFocus.find('[name="catalogImage2"]').val() + '"></span></figure></li>');
      }
      var catalogImage3path = previewFocus.find('[name="catalogImage3"]').val();
      if (catalogImage3path != undefined) {
          $(this).find('.js_slider ul').slick('slickAdd', '<li><figure class="img"><span><img class="m_imgShadow" src="' + previewFocus.find('[name="catalogImage3"]').val() + '"></span></figure></li>');
      }

      var previewIntervalId = setInterval(function(){
          if (previewFocus.find('.catalogTitleLink').text() != "") {
              var dataTrack = previewFocus.find('[name="catalogTdEvParam"]').data('track');
              $("#previewCatalogTitle").text(previewFocus.find('.catalogTitleLink').text());
              $("#previewCatalogLink").attr({"href":previewFocus.find('[name="catalogPageUrl"]').val()});
              mergeDataTrack($("#previewCatalogLink",previewFocus), dataTrack);
              $("#previewCatalogSubtitle").text(previewFocus.find('[name="catalogSubtitle"]').val());
              $("#previewCatalogDescription").text(previewFocus.find('[name="catalogDescription"]').val());
              initializeReadMoreParagraph();
              $("#previewCatalogType").text(previewFocus.find('[name="catalogDocumentTypeLabel"]').val());
              $("#previewCatalogCompanyName").text(previewFocus.find('.catalogCompanyLink').text());
              $("#previewCatalogCompanyLogo").attr({"src":previewFocus.find('[name=catalogCompanyLogoUrl]').val()});
              //$("#previewCatalogDownloadLink").attr({"onclick":previewFocus.find('.catalogDownloadLink').attr("onclick")});
            var getFocused = previewFocus.find('.catalogDownloadLink');
            if(getFocused.data('company_id')!=''){
                $("#previewCatalogDownloadLink").data('company_id',getFocused.data('company_id'));
            } else {
                $("#previewCatalogDownloadLink").data('company_id',getFocused.data('ev_company_id'));
            }
            if(getFocused.data('catalog_id')!=''){
                $("#previewCatalogDownloadLink").data('catalog_id',getFocused.data('catalog_id'));
            } else {
                $("#previewCatalogDownloadLink").data('catalog_id',getFocused.data('ev_catalog_id'));
            }
            mergeDataTrack($("#previewCatalogDownloadLink",previewFocus), dataTrack);
            $("#previewCatalogDataSize").text(previewFocus.find('[name="catalogDocumentSizeBytes"]').val());
            clearInterval(previewIntervalId);
            previewFocus = null;
          }
      }, 300);

      $("#catalogDownloadModal").on("show.bs.modal",function(){
          $("#catalogPreviewModal").find(".modal-content").animate({"opacity":0}, 200);
          $(this).trigger('focus');
      });
      $("#catalogDownloadModal").on("hidden.bs.modal",function(){
          $("#catalogPreviewModal").find(".modal-content").css({"opacity":1});
      });

  });

  function mergeDataTrack(element, param) {
    var data = element.attr('data-track');
    if( typeof data !== 'undefined' && data !== false ){
        data = $.parseJSON(data);
    } else {
        data = $.parseJSON('{}');
    }
    $.extend(data, param);
    
    var arr = [];
    $.each(data, function(key, val) {
        var next = key + '":"';
        next += val;
        arr.push( next );
    });
    element.attr({"data-track": '{"'+arr.join('","')+'"}'});
  }

});